import {
  DocumentTypesInfiniteSelectField,
  FloatingFormItem,
  InputDate,
  PlanAccountsSelect,
} from '@/components/_common';
import { EmployeeCommissionListFormValues } from '@/core/domain/enterprise/EmployeeCommission/EmployeeCommission.types';
import {
  PlanAccountDestination,
  PlanAccountHierarchy,
} from '@/core/domain/enterprise/PlanAccounts/PlanAccounts.types';
import { useDefaultEmptyFieldError } from '@/hooks';
import {
  Alert,
  Checkbox,
  Col,
  Form,
  Input,
  Modal,
  ModalProps,
  Row,
} from 'antd';
import { FormInstance } from 'antd/es/form/Form';

interface Props extends ModalProps {
  form: FormInstance<EmployeeCommissionListFormValues>;
  onOk: () => void;
  onCancel: () => void;
}

const EmployeePayCommissionsModal = ({ form, ...props }: Props) => {
  const defaultEmptyFieldError = useDefaultEmptyFieldError();

  const isGenerateAccountsPayable = Form.useWatch(
    'isGenerateAccountsPayable',
    form,
  );

  return (
    <Modal
      {...props}
      title="Quitar comissões selecionadas"
      okText="Quitar comissões"
      width="70%"
      destroyOnClose
      onOk={() => {
        props.onOk();
        props.onCancel();
      }}
    >
      {isGenerateAccountsPayable && (
        <Alert
          type="warning"
          description="Atenção: Ao gerar a conta a pagar, o documento será registrado com situação 'Aberto'. 
          O pagamento efetivo deverá ser realizado através do módulo de Contas a Pagar."
          style={{ marginBottom: 16 }}
        />
      )}

      <p>Informe a data de pagamento das comissões selecionadas.</p>

      <Form form={form} preserve={false}>
        <Row gutter={[16, 16]}>
          <Col span={24} md={12}>
            <FloatingFormItem
              name="comissionDate"
              label="Data de pagamento"
              rules={[{ required: true }]}
            >
              <InputDate />
            </FloatingFormItem>
          </Col>

          <Col span={24} md={12}>
            <FloatingFormItem
              name="comissionObservation"
              label="Observação"
              extra="Esta observação substituirá todas as anteriores nos itens selecionados"
            >
              <Input />
            </FloatingFormItem>
          </Col>

          <Col span={24} md={12}>
            <FloatingFormItem
              name="isGenerateAccountsPayable"
              valuePropName="checked"
            >
              <Checkbox>Gerar contas a pagar</Checkbox>
            </FloatingFormItem>
          </Col>

          {isGenerateAccountsPayable && (
            <>
              <Col span={24} md={12}>
                <FloatingFormItem
                  name="isGroupPayableByEmployee"
                  valuePropName="checked"
                >
                  <Checkbox>
                    Agrupar contas a pagar por funcionário/empresa
                  </Checkbox>
                </FloatingFormItem>
              </Col>

              <Col span={24} md={12}>
                <FloatingFormItem
                  label="Plano de Contas"
                  name="planAccountId"
                  rules={[defaultEmptyFieldError]}
                >
                  <PlanAccountsSelect
                    queryFilter={{
                      hierarchy: PlanAccountHierarchy.Analitical,
                      destination: PlanAccountDestination.Expense,
                      active: true,
                    }}
                  />
                </FloatingFormItem>
              </Col>

              <Col span={24} md={12}>
                <FloatingFormItem
                  label="Tipo de Documento"
                  name="documentTypeId"
                  rules={[defaultEmptyFieldError]}
                >
                  <DocumentTypesInfiniteSelectField />
                </FloatingFormItem>
              </Col>
            </>
          )}
        </Row>
      </Form>
    </Modal>
  );
};

export default EmployeePayCommissionsModal;
